import { FormInstance } from 'antd/lib/form';
import decodeApiMessage from 'common/helper/decodeApiMessage';
import { notifyError, notifySuccess } from 'common/helper/notifications';
import { GradePostModel } from 'data/grade/grade.model';
import { onGetGrade, onGetGradeSubjects, onSetGrade } from 'data/grade/grade.service';
import { useDispatch } from 'react-redux';
import gradeSlice from 'redux/slice/grade.slice';
import gradeSubjectsSlice from 'redux/slice/gradeSubject.slice';

export const useGrade = () => {
  const dispatch = useDispatch();
  const fetchGrade = async () => {
    dispatch(gradeSlice.actions.setLoading());
    try {
      const res = await onGetGrade();
      dispatch(gradeSlice.actions.setData(res));
    } catch (err) {
      dispatch(gradeSlice.actions.setError(err));
    }
  };

  const fetchGradeSubjects = async (grade: string) => {
    dispatch(gradeSubjectsSlice.actions.setLoading());
    try {
      const res = await onGetGradeSubjects(grade);
      dispatch(gradeSubjectsSlice.actions.setData(res));
    } catch (err) {
      dispatch(gradeSubjectsSlice.actions.setError(err));
    }
  };

  const onSaveGrade = async (
    payload: GradePostModel,
    form: FormInstance,
    onVisibleChange: any,
    onReload: any,
  ) => {
    try {
      await onSetGrade(payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
        onReload(true);
      });
      notifySuccess('Success', 'Subject successfully added.');
    } catch (err) {
      onVisibleChange(true);
      onReload(false);
      notifyError('Error', decodeApiMessage(err));
    }
  };

  return { fetchGrade, fetchGradeSubjects, onSaveGrade };
};
